<template>
  <!-- Main content -->
  <section class="content">
    <!-- Info boxes -->
    <div class="row">
      <v-app>
        <v-content>

          <v-flex xs6 pa-4 v-if="message || error">
              <v-alert
                value="message" v-if="message"
                type="success"
                outline
              > <span> {{ message }} </span>
              </v-alert>

               <v-alert
                value="error" v-if="error"
                type="warning"
                outline
              > <span> {{ error }} </span>
              </v-alert>
          </v-flex>

          <v-container fluid>
           <v-dialog v-model="dialog" max-width="700px" class="mt-3">
            <v-card>
              <v-card-title>
                <span class="headline">{{ request }} Merchant Creation Request</span>
              </v-card-title>
    
              <v-card-text>
                <v-container grid-list-md>
                  <v-layout wrap>
                   <v-form ref="form" v-model="valid" lazy-validation>
                      <v-text-field 
                       v-model="editedItem.name" 
                       label="Name" 
                       required
                       readonly
                       >
                       </v-text-field>

                      <v-text-field 
                       v-model="editedItem.merchantId" 
                       label="Merchant Id"
                       required
                       readonly
                       >
                       </v-text-field>

                       <v-text-field 
                       v-model="editedItem.makerUsername" 
                       label="Maker Username"
                       required
                       readonly
                       >
                       </v-text-field>


                      <v-text-field 
                       v-model="editedItem.checkerComment" 
                       label="Checker Comment"
                       :rules="commentRules"
                       required
                       >
                      </v-text-field>
                    </v-form>
                  </v-layout>
                </v-container>
              </v-card-text>
    
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="secondary" @click.native="close">Cancel</v-btn>
                <v-btn color="primary" @click.native="save">Submit</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
            <v-layout row pr-1 mr-1 pb-1 mb-1>
              <v-spacer></v-spacer>
              <v-flex xs3>
              <v-text-field
                v-model="search"
                append-icon="search"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </v-flex>
           </v-layout>
            <v-data-table
              :headers="headers"
              :items="merchants"
              :pagination.sync="pagination"
              :total-items="totalMerchantsRequests"
              :loading="loading"
              class="elevation-1"
              item-key="merchantTempId"
              :search="search"
            >
            <template
              slot="headerCell"
              slot-scope="{ header }"
            >
              <span
                class="body-2 font-weight-regular accent--text"
                v-text="header.text"
              />
            </template>
            <template slot="items" slot-scope="props">
              <td>{{ props.item.name }}</td>
              <td>{{ props.item.merchantId }}</td>
              <td>{{ props.item.makerUsername }}</td>
              <td>{{ props.item.makerComment }}</td>
              <td>{{ props.item.requestType }}</td>
              <td>{{ props.item.parentId }}</td>
              <td>{{ props.item.createdAt }}</td>
              <td class="justify-center layout px-0">
                <v-btn color="secondary" @click="approveItem(props.item)">
                  Approve
                </v-btn>
                <v-btn color="error" @click="declineItem(props.item)">
                  Decline
                </v-btn>
              </td>
            </template>
            <template slot="no-data">
              <p> No data Found </p>
              <v-btn color="primary" @click="getDataFromApi">Reload</v-btn>
            </template>
           </v-data-table>

          </v-container>
        </v-content>
      </v-app>
    </div>
    <!-- /.row -->
  </section>
  <!-- /.content -->
</template>
<script>
import axios from 'axios'
import config from '../../../config'
import store from '../../../store'

export default {
  name: 'viewmerchantapprovalrequests',
  data: function() {
    return {
      headers: [
        {
          text: 'Name',
          value: 'name'
        },
        { text: 'Merchant Id', value: 'merchantId' },
        { text: 'Maker Username', value: 'makerUsername' },
        { text: 'Maker Comment', value: 'makerComment' },
        { text: 'Request Type', value: 'requestType' },
        { text: 'Parent Id', value: 'id' },
        { text: 'Created At', value: 'createdAt' }
      ],
      merchants: [],
      message: '',
      error: '',
      loading: true,
      pagination: {sortBy: 'created_at', descending: true},
      totalMerchantsRequests: 0,
      dialog: false,
      editedIndex: -1,
      defaultItem: {
        merchantTempId: '',
        name: '',
        merchantId: '',
        makerUsername: '',
        makerComment: ' ',
        requestType: ''
      },
      editedItem: {
        merchantTempId: '',
        name: '',
        merchantId: '',
        makerUsername: '',
        makerComment: ' ',
        requestType: ''
      },
      valid: true,
      request: '',
      commentRules: [
        v => !!v || 'Comment is required'
      ],
      search: ''
    }
  },
  watch: {
    pagination: {
      handler () {
        this.getDataFromApi()
          .then(data => {
            // this.users = data.items
            // this.totalUsers = data.total
          })
      },
      deep: true
    }
  },
  mounted () {
    this.getDataFromApi()
      .then(data => {
        // this.users = data.items
        // this.totalUsers = data.total
      })
  },
  methods: {
    getDataFromApi () {
      this.loading = true
      return new Promise((resolve, reject) => {
        const { sortBy, descending, page, rowsPerPage } = this.pagination
        let items = this.getPendingApprovalRequests()
        const total = items.length

        if (this.pagination.sortBy) {
          items = items.sort((a, b) => {
            const sortA = a[sortBy]
            const sortB = b[sortBy]

            if (descending) {
              if (sortA < sortB) return 1
              if (sortA > sortB) return -1
              return 0
            } else {
              if (sortA < sortB) return -1
              if (sortA > sortB) return 1
              return 0
            }
          })
        }

        if (rowsPerPage > 0) {
          items = items.slice((page - 1) * rowsPerPage, page * rowsPerPage)
        }

        setTimeout(() => {
          this.loading = false
          resolve({
            items,
            total
          })
        }, 1000)
      })
    },
    approveItem (item) {
      this.editedIndex = this.merchants.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
      this.request = 'Approve'
      this.editedItem.approvalStatus = 'approved'
    },
    declineItem (item) {
      this.editedIndex = this.merchants.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
      this.request = 'Decline'
      this.editedItem.approvalStatus = 'declined'
    },
    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    save () {
      if (this.$refs.form.validate()) {
        if (this.editedItem.approvalStatus === 'approved') {
          this.sendRequest('approve')
        } else if (this.editedItem.approvalStatus === 'declined') {
          this.sendRequest('decline')
        }
        this.close()
      }
    },
    sendRequest(request) {
      var url = config.serverURI + '/merchant/create/' + request
      var token = store.state.token
      console.log(this.editedItem)
      axios.post(url, this.editedItem, {
        headers: {
          'Authorization': token,
          'Content-Type': 'application/json'
        }
      })
          .then(response => {
            console.log('Update Response:', response)
            if (response.status !== 200) {
              this.error = response.statusText
              console.log('Error is ' + this.error)
              return
            }
            this.getPendingApprovalRequests()
            this.message = response.data.message
          })
          .catch(error => {
            // Request failed.
            console.log('error', error.response)
            var data = error.response.data
            console.log(data.message)
            if (data.message === 'Unauthorized') {
              console.log('redirecting')
              window.location = '/login'
            } else {
              this.error = data.message
            }
          })
    },
    getPendingApprovalRequests () {
      var url = config.serverURI + '/merchant/approval/requests'
      var token = store.state.token
      axios.get(url, {
        headers: {
          'Authorization': token,
          'Content-Type': 'application/json'
        }
      })
          .then(response => {
            console.log('API Response:', response)

            if (response.status !== 200) {
              this.error = response.statusText
              console.log('Error is ' + this.error)
              return
            }
            this.merchants = response.data
            this.totalMerchantsRequests = this.merchants.total
          })
          .catch(error => {
            // Request failed.
            console.log('error', error.response)
            var data = error.response.data
            console.log(data.message)
            if (data.message === 'Unauthorized') {
              console.log('redirecting')
              window.location = '/login'
            } else {
              this.error = data.message
            }
          })
      return this.merchants
    }
  }
}

</script>
<style>
.info-box {
  cursor: pointer;
}

.info-box-content {
  text-align: center;
  vertical-align: middle;
  display: inherit;
}

.fullCanvas {
  width: 100%;
}

</style>



// WEBPACK FOOTER //
// approvemerchant.vue?29863618